import React from 'react';

/**
 * Parseur markdown léger — suffisant pour le rendu cabinet du `content_md`
 * produit par Claude. Supporte : H1/H2/H3, paragraphes, listes à tirets,
 * gras `**…**`, italique `*…*`. Pas de table, pas de lien, pas de HTML brut
 * (conscient — on évite les surfaces XSS sur du contenu LLM).
 */

function inlineFormat(text) {
  if (!text) return null;
  const parts = [];
  const regex = /(\*\*[^*]+\*\*|\*[^*]+\*)/g;
  let lastIdx = 0;
  let match;
  let key = 0;
  while ((match = regex.exec(text)) !== null) {
    if (match.index > lastIdx) parts.push(text.slice(lastIdx, match.index));
    const m = match[0];
    if (m.startsWith('**')) {
      parts.push(<strong key={key++} className="font-medium text-cabinet-ink">{m.slice(2, -2)}</strong>);
    } else {
      parts.push(<em key={key++} className="italic">{m.slice(1, -1)}</em>);
    }
    lastIdx = regex.lastIndex;
  }
  if (lastIdx < text.length) parts.push(text.slice(lastIdx));
  return parts;
}

export default function MarkdownText({ text, className = '' }) {
  if (!text) return null;
  const blocks = String(text).split(/\n\s*\n/).map((b) => b.trim()).filter(Boolean);
  return (
    <div className={className} data-testid="markdown-text">
      {blocks.map((block, i) => {
        if (block.startsWith('### ')) {
          return <h3 key={i} className="font-manrope font-medium text-[16px] text-cabinet-ink mt-6 mb-2">{inlineFormat(block.slice(4))}</h3>;
        }
        if (block.startsWith('## ')) {
          return <h2 key={i} className="font-playfair text-[18px] text-cabinet-ink mt-8 mb-3">{inlineFormat(block.slice(3))}</h2>;
        }
        if (block.startsWith('# ')) {
          return <h1 key={i} className="font-playfair text-[22px] text-cabinet-ink mt-8 mb-4">{inlineFormat(block.slice(2))}</h1>;
        }
        if (block.split('\n').every((l) => l.trim().startsWith('- '))) {
          const items = block.split('\n').map((l) => l.replace(/^-\s*/, '').trim()).filter(Boolean);
          return (
            <ul key={i} className="space-y-2 my-4">
              {items.map((item, j) => (
                <li key={j} className="text-[14px] text-cabinet-ink leading-[1.7] flex gap-3">
                  <span className="text-cabinet-bordeaux mt-1 font-medium select-none">—</span>
                  <span className="flex-1">{inlineFormat(item)}</span>
                </li>
              ))}
            </ul>
          );
        }
        return <p key={i} className="text-[14px] text-cabinet-ink leading-[1.7] my-3">{inlineFormat(block)}</p>;
      })}
    </div>
  );
}
